import {
  Offer,
  SkuClickCategory,
  PaymentWithSituationParams
} from "@/services/offer/offer_handle";
import { router, store, Vue } from "@/main";
import * as cg_user_types from "@/store/constants/cg_user_types";
import CoinContent from "@/components/DlalogTsx/NotCoinEnough/CoinContent";
import CommentHeader from "@/components/DlalogTsx/CheckAccount/CommentHeader";
import ConfirmOrderHeader from "@/components/DlalogTsx/LargePurchase/ConfirmOrderHeader";
import ConfirmContent from "@/components/DlalogTsx/LargePurchase/ConfirmContent";
import IntervalTimer from "@/components/DlalogTsx/interval_timer";
import ConfirmBtn from "@/components/DlalogTsx/LargePurchase/ConfirmBtn";
import PostContent from "@/components/DlalogTsx/CheckAccount/PostContent";
import FollowContent from "@/components/DlalogTsx/CheckAccount/FollowContent";
import paymentCheckModule from "@/services/payment/payment_check/index";
import { privateUserConfirm, enableMediaComment } from "./payment_check_helper";

/**
 * 购买前检查相关的弹框
 */

export const coinsNotEnoughDialog = (params: PaymentWithSituationParams) => {
  const { offer } = params;
  Vue.prototype.$_Dialog.show({
    title: "Not Enough Coins ?",
    avatar: require("@/assets/icons-file/dialog/coins_not_enough.png"),
    avatarstyle: {
      width: "100px",
      height: "100px",
      background: "rgb(233,236,240)",
      borderRadius: "50%"
    },
    contentCustom(ctx: any, r: any) {
      const user_coins = store.getters[cg_user_types.GETTER_COINS];
      return r(CoinContent, { props: { ctx, offer, user_coins } });
    },
    closable: true,
    confirmBtn: {
      text: "RECHARGE"
    },
    onConfirm(done: any) {
      done();
      router.push({
        name: "CoinStore",
        query: {
          routerTransition: "up",
          slideIndex: "0"
        }
      });
    },
    // cancelBtn: {
    //   text: "FREE COINS"
    // },
    // onCancel(done: any) {
    //   done();
    //   router.push({
    //     name: "CoinStore",
    //     query: {
    //       routerTransition: "up",
    //       slideIndex: "1"
    //     }
    //   });
    // },
    onModalCloseWithIcon(done: any) {
      done();
    }
  });
};

export const turnOnCommentImmediateDialog = (
  params: PaymentWithSituationParams
) => {
  Vue.prototype.$_Dialog.show({
    title: "Turn On Commenting",
    headerCustom(ctx: any, r: any) {
      return r(CommentHeader, { props: { ctx } });
    },
    content: {
      text: `Please <% Turn On Commenting of the post /%> first in order to get comments fast.`,
      highlightColor: "rgb(79,121,255)"
    },
    closable: true,
    onModalCloseWithIcon(done: any) {
      done();
    },
    confirmBtn: {
      text: "OK"
    },
    onConfirm: async (done: any) => {
      done();
      enableMediaComment();
    },
    cancelBtn: {
      text: "CANCEL"
    },
    onCancel(done: any) {
      done();
    }
  });
};

export const turnOnCommentToInstagram = () => {
  Vue.prototype.$_Dialog.show({
    title: "Turn On Commenting",
    headerCustom(ctx: any, r: any) {
      return r(CommentHeader, { props: { ctx } });
    },
    content: {
      text: `In order to use our services, we do require you to turn on commenting of the post in instagram’s setting first.`
    },
    closable: true,
    confirmBtn: {
      text: "OK"
    },
    onConfirm(done: any) {
      done();
    }
  });
};

export const largePurchaseConfirm = (params: PaymentWithSituationParams) => {
  const { offer } = params;
  Vue.prototype.$_Dialog.show({
    title: "Confirm Order",
    headerCustom(ctx: any, r: any) {
      return r(ConfirmOrderHeader, { props: { ctx, offer } });
    },
    contentCustom(ctx: any, r: any) {
      return r(ConfirmContent, { props: { ctx, offer } });
    },
    closable: true,
    onModalCloseWithIcon(done: any) {
      done();
      clearInterval(IntervalTimer.getTimer());
    },
    confirmBtnCustom(ctx: any, r: any) {
      return r(ConfirmBtn, {
        props: { ctx, offer }
      });
    },
    cancelBtn: {
      text: "Not Now"
    },
    onCancel(done: any) {
      clearInterval(IntervalTimer.getTimer());
      done();
    }
  });
};

export const showPrivateDialog = (
  params: PaymentWithSituationParams,
  isFollow: boolean
) => {
  Vue.prototype.$_Dialog.show({
    avatar: require("@/assets/icons-file/login/private@3x.png"),
    title: "Private Account",
    contentCustom(ctx: any, r: any) {
      return r(isFollow ? FollowContent : PostContent, { props: { ctx } });
    },
    closable: true,
    confirmBtn: {
      text: "OK"
    },
    onModalCloseWithIcon(done: any) {
      done();
    },
    onConfirm(done: any) {
      done();
      privateUserConfirm(params);
    },
    cancelBtn: isFollow
      ? {
          text: "CONTINUE AS PRIVATE"
        }
      : {},
    onCancel(done: any) {
      done();
      setTimeout(() => {
        paymentCheckModule.get().next();
      }, 0);
    }
  });
};
